import { useCallback } from "react";

import { AbfLoanExpanded, AbfOrderFundingType, useAbfFetches } from "@bridgesplit/abf-react";
import { useAlert } from "@bridgesplit/react";
import { useGetToggleLoanPositionWithSignature } from "app/components/transactions";

export function useToggleLoanTypeFlow() {
    const toggleLoanPosition = useGetToggleLoanPositionWithSignature();
    const { resetLoanApi, resetRewardsApi, resetNapoleonApi, resetUserApi } = useAbfFetches();
    const { alert } = useAlert();

    return useCallback(
        async (loanExpanded: AbfLoanExpanded | undefined, options?: { onSuccess?: () => void }) => {
            if (!loanExpanded?.loan?.address) return;

            const isLoop = loanExpanded.loanType === AbfOrderFundingType.Loop;
            const targetView = isLoop ? "Loan" : "Loop";

            const res = await toggleLoanPosition({ loanAddress: loanExpanded.loan.address });
            if (!res.isOk()) {
                alert(res.unwrapErrMessage(), "error");
                return;
            }

            resetUserApi();
            resetLoanApi();
            resetRewardsApi();
            resetNapoleonApi();

            alert(`Switched position to display as ${targetView}`, "success");
            options?.onSuccess?.();
        },
        [alert, resetLoanApi, resetNapoleonApi, resetRewardsApi, resetUserApi, toggleLoanPosition]
    );
}
